import { render, staticRenderFns } from "./TemplateSelector.vue?vue&type=template&id=bfa8a2dc&scoped=true"
import script from "./TemplateSelector.vue?vue&type=script&lang=js"
export * from "./TemplateSelector.vue?vue&type=script&lang=js"
import style0 from "./TemplateSelector.vue?vue&type=style&index=0&id=bfa8a2dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfa8a2dc",
  null
  
)

export default component.exports